import React from 'react'
import {style} from 'util/style'
import {WorldmapSvg} from './WorldmapSvg'
import './Worldmap.scss'
const styles = style('worldmap')
export type ContinentType = {
	onClick: (continent: ContinentsType) => void
	highlighted: boolean
}
export type ContinentsType = 'middle-east' | 'america' | 'africa'
type WorldmapType = {
	highlightedContinent: ContinentsType
	onContinentSelect: (continent: string) => void
}

export const Worldmap: React.FC<WorldmapType> = ({
	highlightedContinent,
	onContinentSelect
}) => {
	return (
		<div className={styles}>
			<WorldmapSvg
				onClick={onContinentSelect}
				highlighted={highlightedContinent}
			/>
		</div>
	)
}
